import { useEffect, useMemo, useRef, useState } from "react";

import { apiErrorEmitter } from "api/axios";
import { IApiErrorDetails } from "api/axios/types";
import { ONE, ZERO } from "utils/constants";

const SUCCES_STATUS_CODE = 200;
export const useFilterQueryParams = (payload: { apiFilterRoute: string }) => {
  const { apiFilterRoute } = payload;
  const [isFilterError, setIsFilterError] = useState(false);
  const filterRetryCountRef = useRef(ZERO);

  const filterRetryCountParams: Record<string, string | null> = useMemo(
    () =>
      isFilterError
        ? {
            filterRetryCount: filterRetryCountRef.current.toString(),
          }
        : { filterRetryCount: null },
    [filterRetryCountRef, isFilterError]
  );

  const handleError = (errorDetails: IApiErrorDetails) => {
    const { url, data, status } = errorDetails;
    const routeUrl = url.split("?")?.[ZERO];
    if (
      apiFilterRoute === routeUrl &&
      (data?.error || status !== SUCCES_STATUS_CODE)
    ) {
      setIsFilterError(true);
      filterRetryCountRef.current += ONE;
    } else {
      setIsFilterError(false);
    }
  };

  useEffect(() => {
    apiErrorEmitter.on("apiError", handleError);

    return () => {
      apiErrorEmitter.off("apiError", handleError);
    };
  }, []);

  return {
    isFilterError,
    setIsFilterError,
    filterRetryCountParams,
  };
};
